<template>
  <!-- Edit Customer Button -->
  <q-btn
    color="amber"
    icon="edit"
    label="Guncelle"
    no-caps
    @click="prompt = true"
  />

  <!-- Edit Customer Form -->
  <q-dialog v-model="prompt">
    <CustomerForm is-editing :customer="customer" />
  </q-dialog>
</template>
<script>
import { ref } from 'vue'
import CustomerForm from './Form.vue'
export default {
  components: {
    CustomerForm,
  },
  props: {
    customer: Object,
  },
  setup() {
    return {
      prompt: ref(false),
    }
  },
}
</script>
